import {HidePreviewTypes} from '../constants/hide-preview-types.const';

export const showPreview = (type: string) => {
  return !HidePreviewTypes.includes(type);
};
